import styled from "styled-components";

export const Component = styled.h3`
	margin:0px;
`;
